import type { Team } from "../../../types/form";
import type { FieldRegistryConfig } from "../../types";
import { defaultToReviewString } from "../review/reviewString.helpers";
import { TeamFieldControl } from "./TeamFieldControl/TeamFieldControl";
import { prefillTeam } from "./team.prefill";

export type TeamFormValue = Team & {
  team: Team;
};

export type TeamFieldValue = string[];

/**
 * Stores the team object both at top level (for ID access) and nested in the 'team' key
 * (for name-based comparisons in conditional visibility logic).
 * The nested 'team' field is used by formValueFormatters.ts to extract names for
 * "contains"/"not_contains" comparisons.
 *
 * When submitting the form, we send only the IDs.
 */
export const teamFieldConfig: FieldRegistryConfig<TeamFormValue[], TeamFieldValue> = {
  icon: "team",
  control: TeamFieldControl,
  convertFormValueToApi: (value) => value.map((v) => v.id),
  prefill: prefillTeam,
  toReviewString: defaultToReviewString,
};
